import { z } from "zod";
import {
  EquipmentSchema,
  createEquipmentSchema,
  updateEquipmentSchema,
  EquipmentStatusEnum,
  WarrantyStatusEnum,
} from "@/lib/validations/business/equipment";

/** Fields that can be edited in equipment */
export type EquipmentEditableField =
  | "name"
  | "serial_number"
  | "manufacturer"
  | "year"
  | "purchase_date"
  | "purchase_price"
  | "location"
  | "status"
  | "last_inspection"
  | "next_inspection"
  | "warranty_status";

/** Interface defining permissions for equipment fields */
export interface EquipmentFieldPermissions {
  editable: EquipmentEditableField[];
  viewable: EquipmentEditableField[];
}

/** Fields that can be used for sorting equipment */
export const EquipmentSortable = [
  "name",
  "manufacturer",
  "year",
  "purchase_date",
  "status",
  "last_inspection",
  "next_inspection",
  "created",
  "updated",
] as const;
export type EquipmentSortField = (typeof EquipmentSortable)[number];

/** Equipment status type */
export type EquipmentStatus = z.infer<typeof EquipmentStatusEnum>;

/** Warranty status type */
export type WarrantyStatus = z.infer<typeof WarrantyStatusEnum>;

/** Complete equipment type with all fields */
export type Equipment = z.infer<typeof EquipmentSchema>;

/** Type for creating new equipment */
export type CreateEquipmentInput = z.infer<typeof createEquipmentSchema>;

/** Type for updating existing equipment */
export type UpdateEquipmentInput = z.infer<typeof updateEquipmentSchema>;

/** Equipment with relationships and additional data */
export interface EquipmentWithRelations extends Equipment {
  jobtasks?: Array<{ id: string; name: string }>;
}

export interface SimpleEquipment {
  id: string;
  name: string;
}
